export default (rawElement: HTMLElement) => {
  if (rawElement.tagName.toLowerCase() !== 'dialog') {
    console.error(
      'openDialog component can only be applied to <dialog> elements',
      rawElement,
    );
    return;
  }
  const element = rawElement as HTMLDialogElement;
  if (
    typeof (element as HTMLDialogElement).showModal !== 'function' ||
    typeof (element as HTMLDialogElement).close !== 'function'
  ) {
    console.error('Your browser does not support HTMLDialogElement.');
    return;
  }

  const dialogId = element.id;

  // reset all forms inside the dialog when it's closed
  element.addEventListener('close', () => {
    const forms = element.querySelectorAll('form');
    forms.forEach((form) => {
      form.reset();
    });

    // Remove hash if it matches this dialog
    if (window.location.hash === `#${dialogId}`) {
      history.pushState(
        '',
        document.title,
        window.location.pathname + window.location.search,
      );
    }
  });

  // close the dialog when clicking on elements with data-dialog-close attribute
  element.querySelectorAll('[data-dialog-close]').forEach((btn) => {
    btn.addEventListener('click', () => {
      (element as HTMLDialogElement).close();
    });
  });

  // if has data-dialog-open attribute, open the dialog
  if (element.hasAttribute('data-dialog-open')) {
    (element as HTMLDialogElement).showModal();
  }

  // Check if URL hash matches this dialog and open it
  if (window.location.hash.slice(1) === dialogId) {
    (element as HTMLDialogElement).showModal();
  }

  window.addEventListener('hashchange', () => {
    if (window.location.hash.slice(1) === dialogId) {
      (element as HTMLDialogElement).showModal();
    }
  });
};
